export enum TaskDirectionFullNames {
  'Inbound' = 0,
  'Outbound' = 1,
}
